import React from "react";
import styled from "styled-components";
import * as Icons from "react-icons/fa";

import { SanitySocialMediaNav } from "@graphql-types";
import { colors } from "@util/constants";

export type IconKeys = keyof typeof Icons;

interface Props {
  data: SanitySocialMediaNav;
  darkBackground?: boolean;
}

const StyledSomething = styled.span<{
  backgroundDark: boolean | undefined;
}>`
border: 1px solid white;
border-radius: 50%;
  svg{
    width: 20px;
    height: 20px;
    ${({ backgroundDark }) => backgroundDark && `color:${colors.white};`};
  }
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }
`

function SocialIcon({ data, darkBackground }: Props) {
  if (data == null) return null;

  const { externalLink, icon } = data;

  const IconComponent = Icons[(icon?.name as IconKeys) ?? "FaLink"];

  return (
    <StyledSomething backgroundDark={darkBackground}>
      <a href={externalLink as string} target="_blank">
        <IconComponent />
      </a></StyledSomething>
  );
}

export default SocialIcon;
